//const DEFAULT_LOCAL_API_URL = 'https://localhost:7001/api';
const DEFAULT_LOCAL_API_URL = 'https://sibylcues.com/sibylapis/api';

const normalizeUrl = (url) => url.replace(/\/+$/, '');

const getBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return normalizeUrl(process.env.REACT_APP_API_BASE_URL);
  }

  return DEFAULT_LOCAL_API_URL;
};

const API_BASE_URL = normalizeUrl(getBaseUrl());

export const CONTACT_API_URL = `${API_BASE_URL}/contact`;
export const INTERNSHIP_API_URL = `${API_BASE_URL}/internship`;

export default {
  CONTACT_API_URL,
  INTERNSHIP_API_URL,
};

